import { render, staticRenderFns } from "./EmployeeSlices.vue?vue&type=template&id=efe6bcba&scoped=true&"
import script from "./EmployeeSlices.vue?vue&type=script&lang=js&"
export * from "./EmployeeSlices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efe6bcba",
  null
  
)

export default component.exports